import BaseApi from "./BaseApi";

class AuthApi extends BaseApi{
    async getGoogleInfo(token){
        try{
            const endpoint = `userinfo?access_token=${token}`;
            const response = await this.getGoogleUserInfo(endpoint);
            return response.data;
        }
        catch(error){
            throw new Error("unable to retrieve user info");
        }
    }

    async getUser(email){
        try{
            const endpoint = "api/Auth";
            const response = await this.post(endpoint, email);
            return response.data;
        }
        catch(error){
            if(error.response){
                throw new Error(error.response.data);
            }
            else{
                throw new Error(error);
            }
        }
    }
}

export default new AuthApi();